import { v4 as uuidv4 } from "uuid";
export const experties = [
  {
    id: uuidv4(),
    name: "Taxation and Corporate",
    title: `Business law governs entities and commercial transactions`,
    image: `taxation-and-corporate-law.jpg`,
    description: ` 
    Business law, also known as commercial law, 
    is the generic term for the body of laws that
     govern entities and commercial transactions. 
     For instance, if you wanted to start a shoe company today,
      business law would dictate how to organize and register your company,
       as well as how to pay your employees and even how to legally ship 
       your shoe merchandise to customers overseas.`,
  },
  {
    id: uuidv4(),
    name: "Civil Law",
    title: `The law relating to civil wrongs and
    quasi-contracts is part of the civil law`,
    image: `civil-law.jpeg`,
    description: ` Civil law is a major branch of the law. ... The
    law relating to civil wrongs and quasi-contracts
    is part of the civil law, as is law of property
    (other than property-related crimes, such as theft
    or vandalism). Civil law may, like criminal law,
    be divided into substantive law and procedural
    law.`,
  },
  {
    id: uuidv4(),
    name: "Family Law",
    title: `Family law is a legal practice area that focuses on issues involving family relationships`,
    image: `family-law.jpg`,
    description: ` Family law disputes that are handled in the judicial system include: divorce, separation, adoption, child custody, visitation rights, financial settlements and distribution of assets, domestic violence, guardianship, and child abuse and neglect.`,
  },
  {
    id: uuidv4(),
    name: "Court Marriage",
    title: `The court marriage is a formal union of a man and a woman`,
    image: `court-marriage.jpg`,
    description: ` The court marriage is a formal union of a man and a woman, typically solemnized by legal procedure in the court of law, by which they become husband and wife. Such a marriage is solemnized before the Magistrate/Registrar of the area where both or any of the parties to such a marriage reside.`,
  },
  {
    id: uuidv4(),
    name: "Criminal Law",
    title: `Criminal law, the body of law that defines criminal offenses`,
    image: `criminal-law.jpg`,
    description: ` Criminal law, the body of law that defines criminal offenses, regulates the apprehension, charging, and trial of suspected persons, and fixes penalties and modes of treatment applicable to convicted offenders.`,
  },
  {
    id: uuidv4(),
    name: "Property Law",
    title: `Rights over things enforceable against all other persons`,
    image: `property-law.jpg`,
    description: ` Property law is the area of law that governs the various forms of ownership in real property (land) and personal property. Property refers to legally protected claims to resources, such as land and personal property, including intellectual property`,
  },
];
